<template>
  <div>
    <div>
      <p class="contentType">
        <span>Condition Type:</span>
        <span>{{ formName }}</span>
      </p>
    </div>
    <el-form :model="form" :rules="rules" ref="form">
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="Pricing Rating:" prop="gcrRating">
            <el-select style="width: 300px" v-model="form.gcrRating">
              <el-option
                v-for="option in gcrArr"
                :key="option.value"
                :value="option.value"
                :label="option.label"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Transactional Rating:"
            prop="transactionalRating"
          >
            <el-select style="width: 300px" v-model="form.transactionalRating">
              <el-option
                v-for="option in transArr"
                :key="option.value"
                :value="option.value"
                :label="option.label"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <common-form ref="commonForm" :defaultData="_commonData"></common-form>
  </div>
</template>

<script>
import CommonForm from './common-form'
export default {
  components: { CommonForm },
  data() {
    const gcrArr = [
      { value: 1, label: 1 },
      { value: 2, label: 2 },
      { value: 3, label: 3 },
      { value: 4, label: 4 },
      { value: 5, label: 5 },
      { value: 6, label: 6 },
      { value: 7, label: 7 },
    ]
    const transArr = [
      { value: 'A', label: 'A' },
      { value: 'B', label: 'B' },
      { value: 'C', label: 'C' },
      { value: 'D', label: 'D' },
      { value: 'E', label: 'E' },
    ]
    return {
      gcrArr,
      transArr,
      formName: 'TRX',
      commonFormData: {},
      form: {
        completeAnnualReviewWithinDays: '',
        gcrRating: '',
        transactionalRating: '',
      },
      rules: {
        completeAnnualReviewWithinDays: [
          { required: true, message: 'can not be empty!', trigger: 'blur' },
        ],
        gcrRating: [
          { required: true, message: 'can not be empty!', trigger: 'blur' },
        ],
        transactionalRating: [
          { required: true, message: 'can not be empty!', trigger: 'blur' },
        ],
      },
    }
  },
  computed: {
    _commonData() {
      return {
        ...this.commonFormData,
      }
    },
  },
  watch: {
    d_value: {
      deep: true,
      immediate: true,
      handler(newValue) {
        this.commonFormData = newValue
        this.$set(
          this.form,
          'completeAnnualReviewWithinDays',
          newValue.completeAnnualReviewWithinDays,
        )
        this.$set(this.form, 'gcrRating', newValue.gcrRating)
        this.$set(
          this.form,
          'transactionalRating',
          newValue.transactionalRating,
        )
      },
    },
  },
  props: {
    d_value: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    getFormData() {
      return {
        ...this.form,
        formName: this.formName,
        ...this.$refs.commonForm.getCommonForm(),
      }
    },
    async checkValid() {
      const valid = await this.$refs.form.validate()
      if (valid) {
        return await this.$refs.commonForm.checkCommonValid()
      } else {
        return false
      }
    },
  },
}
</script>

<style scoped lang="less">
.contentType {
  margin-bottom: 10px;

  span {
    font-size: 14px;
    font-weight: bold;
    color: #303133;
    &:first-child {
      margin-right: 10px;
    }
  }
}
</style>
